import { UserNotificationSettings } from "@supernova-studio/model";
import { z } from "zod";
export const DTOUpdateUserNotificationSettingsPayload = z.object({
    notificationSettings: UserNotificationSettings,
});
export const DTOUserNotificationSettingsResponse = z.object({
    userId: z.string(),
    workspaceId: z.string(),
    notificationSettings: UserNotificationSettings,
});
